(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.DrawerSelectionController', drawerSelectionCtrl);
    drawerSelectionCtrl.$inject = ['$scope', '$q', '$translate', '$stateParams', '$uibModal', '$compile', '$document',
                                   '$location', '$http', '$window', '$timeout', '$bentoBusyLoader', 'FlexGridSetUpFactory',
                                   'migrationService'];

    function drawerSelectionCtrl($scope, $q, $translate, $stateParams, $uibModal, $compile, $document, $location,
                                 $http, $window, $timeout, $bentoBusyLoader, flexGridSetUpFactory, migrationService) {
        /*jshint validthis:true */
        var vm = this;
        vm.gridDataTwo = [];                   // it's not updated by bento-flexgrid-transferbox, bug?
        vm.params = {
            orderBy: 'id',
            search: '',
            searchBy: '',
            filter: '',
            startIndex: 0,
            itemsPerPage: 25
        };

        vm.config = {
            availableTitle: $scope.omtrans('DrawerSelect.AvailableDrawers'),
            selectedTitle: $scope.omtrans('DrawerSelect.DrawersAdded'),
            height: 500,
            transferInfoText: $translate.instant('Onvio.Bento.TransferBox.CHECKED'),
            transferBtnText: $scope.omtrans('Label.Migrate'),
            paginationInfoText: $translate.instant('Onvio.Bento.Pagination.INFO_TEXT'),
            paginationInfoPageText: $translate.instant('Onvio.Bento.Pagination.INFO_PAGE_TEXT'),
            boxOneInfoShown: true,
            boxTwoInfoShown: true,
            desktopMode: true,
            filtersShown: true
        };
        vm.config.columnDefinitions = [{
            binding: 'itemId',
            header: $scope.omtrans('DrawerSelect.DrawerId'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'name',
            header: $scope.omtrans('DrawerSelect.Name'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'edited',
            header: $scope.omtrans('DrawerSelect.LastEdited'),
            filter: {
                type: 'input'
            }
        }, {
            binding: 'uploadedText',
            header: $scope.omtrans('Uploaded.Header'),
            filter: {
                type: 'select',
                options: [{
                    name: $scope.omtrans('Uploaded.NotYet'),
                    value: ' '
                }, {
                    name: $scope.omtrans('Uploaded.Yes'),
                    value: 'Yes'
                }, {
                    name: $scope.omtrans('Uploaded.All'),
                    value: null
                }]
            }
        }];

        vm.toggleAll = function toggleAll(box) {
            if (vm.transferbox) {
                vm.transferbox.toggleAll(box);
            }
        };

        vm.onTransfer = function onTransfer(gridDataOne, gridDataTwo) {
            // work-around to record the selected drawers
            $scope.selectedDrawerList.splice(0,  $scope.selectedDrawerList.length);
            gridDataTwo.forEach( function(item) {
                $scope.selectedDrawerList.push(item);
            });
        };

        vm.loadAvailableDrawers = function() {
            $scope.busyLoading = true;
            $scope.loadingFailed = false;
            $scope.availableDrawerList.splice(0, $scope.availableDrawerList.length);
            migrationService.getMigrationProductSets($scope.migrationConfig.companyId, $scope.currentProduct.migrationProductId)
            .then( function(resp) {
                resp.items.forEach( function(itemSet) {
                    var props = vm.getItemProps(itemSet.item);
                    var item = angular.extend(props, itemSet);
                    if (item.uploaded) {
                        item.uploadedText = 'Yes';
                    } else {
                        item.uploadedText = ' ';
                    }
                    $scope.availableDrawerList.push(item);
                });
            }, function() {
                $scope.loadingFailed = true;
            })
            .finally(function() {
                $scope.busyLoading = false;
            });
        };

        vm.getItemProps = function(itemMeta) {
            if ( angular.isUndefined(itemMeta) ) {
                return {};
            }
            var itemJson = JSON.parse(itemMeta);
            var props = {
                name: itemJson.name,
                edited: migrationService.getDateStringShort(itemJson.edited)
            };
            return props;
        };

        $scope.$on('load-drawers', function() {
            vm.loadAvailableDrawers();
        });
    }

})(window.angular);
